import type { ReservationsFilter } from "services/lockerApi";

export const queryKeys = {
  locker: {
    all: ["locker"] as const,
    detail: (lockerId: string) => ["locker", lockerId] as const,
  },
  reservations: (filter: ReservationsFilter = {}) => ["reservations", filter] as const,
  recipients: ["recipients"] as const,
  totpSecrets: ["totpSecrets"] as const,
  inventory: {
    settings: ["inventory", "settings"] as const,
    catalog: (memberId?: string | null) =>
      ["inventory", "catalog", memberId ?? null] as const,
    productInventory: (inventoryId?: string | null) =>
      ["inventory", "productInventory", inventoryId ?? null] as const,
  },
};
